module.exports = __webpack_public_path__ + "img/lens-174-minus-12.66ef2350.png";